// extracted by mini-css-extract-plugin
export default {"select-wrapper":"PageDropdown_select-wrapper__iVGIc","label":"PageDropdown_label__R7Ijv","disabled":"PageDropdown_disabled__pRsCk"};